type QueueItem = {
  resolve: (value: void) => void;
  reject: (reason?: unknown) => void;
};

/**
 * Cola de requests que esperan mientras se refresca el token.
 * Cuando el token se refresca exitosamente, todos los requests
 * encolados se reintentan automáticamente.
 */
export class RequestQueue {
  private queue: QueueItem[] = [];
  private processing = false;

  get isPending(): boolean {
    return this.processing;
  }

  get size(): number {
    return this.queue.length;
  }

  enqueue(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.queue.push({ resolve, reject });
    });
  }

  startProcessing(): void {
    this.processing = true;
  }

  resolveAll(): void {
    this.queue.forEach(({ resolve }) => resolve());
    this.reset();
  }

  rejectAll(error: Error): void {
    this.queue.forEach(({ reject }) => reject(error));
    this.reset();
  }

  private reset(): void {
    this.queue = [];
    this.processing = false;
  }
}
